import React, { useState, useEffect, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Form, Field, reduxForm, formValueSelector, getFormSyncErrors } from 'redux-form';
import PhoneInput from 'react-phone-input-2';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../Common/Loader/Loader';
import CustomCheckbox from '../../Common/CustomCheckbox/CustomCheckbox';

import { setRuntimeVariable } from '../../../actions/runtime';
import validate from './validate';
import submit from './submit';
import messages from '../../../locale/messages';

import n from 'react-phone-input-2/lib/style.css';
import bt from '../../commonStyle.css';
import s from '../../../styles/phoneNumberInput.css'


function LoginForm(props) {
    const {
        handleSubmit,
        intl: { formatMessage },
        loading,
        initialize,
        change,
        siteName,
        referUrl,
    } = props;

    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneCountryCode] = useState('US');
    const [phoneDialCode] = useState('+1');
    const [isAgreePhoneNumberVerification, setIsAgreePhoneNumberVerification] = useState(false)
    const dispatch = useDispatch()
    useEffect(() => {
        initialize({
            phoneCountryCode,
            phoneDialCode
        });
        if (referUrl) {
            change('referUrl', referUrl);
            dispatch(setRuntimeVariable({
                name: 'referUrl',
                value: null,
            }));
        }
    }, []);


    const handleOnChange = useCallback((value, event) => {
        setPhoneNumber(value);
        let phoneNumber = value.replace(/[^0-9]+/g, '').slice(event.dialCode.length);
        change('phoneCountryCode', event.countryCode.toUpperCase());
        change('phoneDialCode', `+${event.dialCode}`);
        change('phoneNumber', phoneNumber);
    }, [change]);

    const handleCheckBox = (value) => {
        setIsAgreePhoneNumberVerification(value)
        change('isAgreePhoneNumberVerification', value);
    }

    const renderField = ({ input, placeholder, label, meta: { touched, error }, ...custom }) => {
        return (
            <div className='guideBookPhoneInput'>
                {label && <label className={bt.commonLabelText}>{label}</label>}
                <PhoneInput
                    country="us"
                    value={phoneNumber}
                    onChange={handleOnChange}
                    countryCodeEditable={false}
                    inputProps={{
                        name: 'phoneNumber',
                        required: true,
                        autoFocus: true
                    }}
                />
                {touched && error && (
                    <span className={bt.errorMessage}>
                        {formatMessage(error)}
                    </span>
                )}
                <div className={cx(bt.spaceTop3, 'commonCustomCheckOuterFlex')}>
                    <CustomCheckbox
                        name={'isAgreePhoneNumberVerification'}
                        checked={isAgreePhoneNumberVerification}
                        onChange={(e) => handleCheckBox(e)}
                        className='commonCustomCheckBox'
                        containerClassName={'commonCustomCheckWithoutLabelFlex'}
                    />
                    <span className={'checkBoxOuterLabel'}>
                        {formatMessage(messages.smsConsentLead, { siteName })}{" "}
                        <a href="/terms" target="_blank" rel="noopener noreferrer" className={bt.commonCardLink}>{formatMessage(messages.termsOfService)}</a>{", "}
                        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className={bt.commonCardLink}>{formatMessage(messages.smsConsentPrivacyLink)}</a>{" "}{formatMessage(messages.smsConsentAnd)}{" "}
                        <a href="/sms-consent" target="_blank" rel="noopener noreferrer" className={bt.commonCardLink}>{formatMessage(messages.smsConsentSmsLink)}</a>{"."}
                    </span>
                </div>
            </div>
        );
    };

    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Field
                    name="phoneNumber"
                    component={renderField}
                    label={formatMessage(messages.mobileNumber)}
                    placeholder={formatMessage(messages.mobileNumberLabel)}
                />
                <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                    <Loader
                        type="button"
                        buttonType="submit"
                        show={loading}
                        label={formatMessage(messages.sendOTP)}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    />
                </div>
            </Form>
        </>
    );
};


LoginForm = reduxForm({
    form: 'LoginForm',
    destroyOnUnmount: false,
    onSubmit: submit,
    validate
})(LoginForm);

const selector = formValueSelector('LoginForm');

const mapState = state => ({
    loading: state?.loader?.smsLoading,
    phoneFieldValue: selector(state, 'phoneFieldValue'),
    phoneNumber: selector(state, 'phoneNumber'),
    phoneDialCode: selector(state, 'phoneDialCode'),
    fieldErrors: getFormSyncErrors('LoginForm')(state),
    siteName: state?.siteSettings?.data?.siteName,
    referUrl: state?.runtime?.referUrl,
});


export default injectIntl(withStyles(n, bt, s)(connect(mapState, {})(LoginForm)));